export function toExternalId(value) {
  if (value == null || value === '') return null;
  return String(value);
}

export function auditorIdFrom(row) {
  return toExternalId(row?.user_id ?? row?.auditorId ?? row?.auditor_id);
}

export function studentIdFrom(row) {
  return toExternalId(row?.id ?? row?.student_id ?? row?.studentId);
}

export function rosterKey(schoolId, branchId) {
  return `${toExternalId(schoolId)}:${toExternalId(branchId) || ''}`;
}

export function entityKey(id) {
  return toExternalId(id) ?? '';
}